export function getResourceURL(resource: string): string {
    return `${process.env.REACT_APP_SCENES_ARTIFACTS_BUCKET_URL}/${resource}`;
}